import React from 'react';
import { AddUserForm } from './AddUserForm';
import { EditUserForm } from './EditUserForm';
import { AddUserFormValues } from './types';

interface UserFormProps {
  onSubmit: (values: AddUserFormValues) => void;
  onCancel: () => void;
  userId?: number;
}

export const UserForm: React.FC<UserFormProps> = ({ onSubmit, onCancel, userId }) => {
  return userId ? (
    <EditUserForm userId={userId} onSubmit={onSubmit} onCancel={onCancel} />
  ) : (
    <AddUserForm onSubmit={onSubmit} onCancel={onCancel} />
  );
};
